import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShoppingBag, Phone } from 'lucide-react';

export default function HeroBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary to-primary-dark px-4 py-20 text-white sm:px-6 lg:px-8 lg:py-28">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 h-72 w-72 rounded-full bg-white" />
        <div className="absolute right-20 bottom-10 h-48 w-48 rounded-full bg-white" />
      </div>

      <div className="relative mx-auto max-w-7xl text-center">
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
          {t('home.heroTitle')}
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg text-white/80 sm:text-xl">
          {t('home.heroSubtitle')}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/products"
            className="flex items-center gap-2 rounded-full bg-white px-8 py-3 text-lg font-semibold text-primary shadow-lg transition-transform hover:scale-105"
          >
            <ShoppingBag size={20} />
            {t('home.heroCTA')}
          </Link>
          <Link
            to="/contact"
            className="flex items-center gap-2 rounded-full border-2 border-white px-8 py-3 text-lg font-semibold text-white transition-colors hover:bg-white/10"
          >
            <Phone size={20} />
            {t('home.heroContactCTA')}
          </Link>
        </div>
      </div>
    </section>
  );
}
